import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const whatsappNumber = '919535217376';
  const message = 'Hello! I would like to inquire about your electronic components.';

  useEffect(() => {
    // Show button after a small delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="whatsapp-button-container">
      <button
        onClick={handleWhatsAppClick}
        className="whatsapp-button"
        aria-label="Contact us on WhatsApp"
      >
        <MessageCircle className="h-6 w-6" />
      </button>
      <div className="whatsapp-tooltip">
        Chat with us on WhatsApp
      </div>
    </div>
  );
};

export default WhatsAppButton;
